import { render, staticRenderFns } from "./pageNotFound.vue?vue&type=template&id=24efdaef&"
import script from "./pageNotFound.vue?vue&type=script&lang=js&"
export * from "./pageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./pageNotFound.vue?vue&type=style&index=0&id=24efdaef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports